import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { createLogger } from './utils/logger';

const logger = createLogger('Index');

// Performance mark for app start
performance.mark('app-init-start');

// Enable React concurrent features
const root = ReactDOM.createRoot(document.getElementById('root'), {
  onRecoverableError: (error) => {
    logger.error('React recoverable error:', error);
  },
});

root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// Performance mark for app render complete
requestAnimationFrame(() => {
  performance.mark('app-init-end');
  performance.measure('app-init', 'app-init-start', 'app-init-end');
  
  const measure = performance.getEntriesByName('app-init')[0];
  logger.info(`App initialized in ${measure.duration.toFixed(2)}ms`);
});

// Register service worker for PWA support
if (process.env.REACT_APP_ENABLE_PWA === 'true') {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      logger.info('New app version available');
      // Could show a toast notification here
    },
    onSuccess: (registration) => {
      logger.info('App is offline-ready');
    },
  });
}

// Report web vitals
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }
  
  // Send to analytics
  if (window.gtag && process.env.REACT_APP_GA_TRACKING_ID) {
    window.gtag('event', metric.name, {
      value: Math.round(metric.value),
      metric_rating: metric.rating,
      non_interaction: true,
    });
  }
});

// Handle uncaught errors
window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection:', event.reason);
});

// Preload critical fonts
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    // Preload any critical fonts or resources
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://fonts.googleapis.com';
    document.head.appendChild(link);
  });
}